import { SelfAssessmentQuestion } from "../types/applicationTypes";

// the questions for the self-assessment
export const selfAssessmentQuestions: { [key: string]: SelfAssessmentQuestion } = {
  question1: {
    label1: "Ich mache gerne mit voller Aufmerksamkeit eine Aufgabe nach der anderen.",
    label2: "Ich arbeite gerne an mehreren Aufgaben gleichzeitig.",
  },
  question2: {
    label1: "Ich bin ein direkter Typ.",
    label2: "Ich bin ein diplomatischer Typ.",
  },
  question3: {
    label1: "In einem Arbeitsteam ist mir der Zusammenhalt besonders wichtig.",
    label2: "In einem Arbeitsteam sind mir Ergebnisse besonders wichtig.",
  },
  question4: {
    label1: "Mir ist wichtig, dass Entscheidungen schnell und zielgerichtet gefällt werden.",
    label2: "Mir ist wichtig, dass alle Beteiligten bei einer Entscheidungsfindung ihre Meinung äußern.",
  },
  question5: {
    label1: "Ich überzeuge bei einer Präsentation mit Charisma.",
    label2: "Ich überzeuge bei einer Präsentation mit Fachwissen.",
  },
  question6: {
    label1: "Ich wende gerne bewährte Lösungswege an, um möglichst schnell gute Ergebnisse zu erzielen.",
    label2: "Ich entwickle und probiere gerne neue Lösungswege.",
  },
  question7: {
    label1: "Ich interessiere mich für Wissen aus einem Spezialgebiet.",
    label2: "Ich interessiere mich für Wissen aus verschiedenen Fächern.",
  },
  question8: {
    label1: "Im JBT möchte ich in Projekten Praxiserfahrungen sammeln.",
    label2: "Im JBT möchte ich mich mit anderen Studenten im Verein engagieren.",
  },
};
